import { Component, OnInit } from '@angular/core';
import { ProviderService } from '../../core/models/provider-service.model';
import { Real } from '../../core/models/real.model';
import { OfferService } from '../../core/services/offer.service';
import { ShopDetailService } from '../../core/services/shop-detail.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, BehaviorSubject, Subject } from 'rxjs';

import { TranslateService } from "@ngx-translate/core";

import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");


@Component({
  selector: 'app-offer',
  templateUrl: './offer.page.html',
  styleUrls: ['./offer.page.scss'],
})
export class OfferPage implements OnInit {

  service$: Observable<ProviderService>
  real$: Observable<Real>

  constructor( private router: Router, private offerService: OfferService, private shopDetailService: ShopDetailService, private route: ActivatedRoute,  private translateService: TranslateService ) { }

  ngOnInit() {
    this.service$ = this.offerService.getService( this.route.paramMap );

    this.real$ = this.shopDetailService.getReal( this.route.paramMap );

  }

  goToPickSlot( real, service ) {

    let queryParamsObj = {};



    if ( 19369 == service.id ) {
      queryParamsObj = { from: '2023-10-16' }
    }

    if ( service.start ) {
      
      let startStr = service.start.substring(0, 10);
      let todayStr = moment().format('YYYY-MM-DD');
      
      if ( startStr > todayStr ) {
        queryParamsObj = { from: startStr };
      }
      
    }

    queryParamsObj['filter'] = service.id.toString();

    this.router.navigate(['/', 'restavracija', real.provider.id, real.slug, 'rezervacija', 'izberi-termin'], { queryParams: queryParamsObj } );
  }
}